import { createSlice } from '@reduxjs/toolkit';

export const coerceToString = (v) => (v === null || v === undefined ? "" : String(v));

const quoteRevisionNotesSlice = createSlice({
    name: 'quoteRevisionNotes',
    initialState: {
        drafts: {}
        // drafts[revisionId] = { value: string, serverValue: string, dirty: boolean }
    },
    reducers: {
        setServerValue: (state, action) => {
            const { revisionId, value } = action.payload;
            const sv = coerceToString(value);
            const entry = state.drafts[revisionId];
            if (!entry) {
                state.drafts[revisionId] = { value: sv, serverValue: sv, dirty: false };
            } else if (entry.dirty) {
                entry.serverValue = sv;
            } else {
                entry.value = sv;
                entry.serverValue = sv;
                entry.dirty = false;
            }
        },
        setDraftValue: (state, action) => {
            const { revisionId, value } = action.payload;
            const v = coerceToString(value);
            const entry = state.drafts[revisionId] || { value: '', serverValue: '', dirty: false };
            entry.value = v;
            entry.dirty = entry.serverValue !== v;
            state.drafts[revisionId] = entry;
        },
        clearDraft: (state, action) => {
            const { revisionId, savedValue } = action.payload;
            const entry = state.drafts[revisionId];
            if (entry) {
                // Important: a save can complete after the user has typed more.
                // If we blindly mark the current value as saved, we can lose unsaved edits.
                if (savedValue !== undefined) {
                    entry.serverValue = coerceToString(savedValue);
                    entry.dirty = entry.value !== entry.serverValue;
                } else {
                    entry.serverValue = entry.value;
                    entry.dirty = false;
                }
            }
        }
    }
});

export const { setServerValue, setDraftValue, clearDraft } = quoteRevisionNotesSlice.actions;
export default quoteRevisionNotesSlice.reducer;
